'use strict'

trace = require('itier-tracing')('pull:pagination')
PaginationSlots = require '../../../../modules/pagination/common/helpers/slots'
qs = require 'qs'
urlParse = require 'url'

clone = require 'lodash/clone'
{ isEmpty } = require '../../../page/helpers/underscore_replacement'
{ toString } = require '../../../page/frontend/helpers/params'
partial = require 'lodash/partial'

module.exports =
  toHash: (attributes, config = {}, modules) ->
    {requestURL, query, currentPageNumber, totalPages, nextPageSize, totalDealCount, startingIndex, endingIndex, limitResults, isHomePage, refererUrl} = attributes
    {minPrice, maxPrice} = query
    {requestURL, query} = getParsedUrlFromQuery(refererUrl) or {requestURL, query}

    if query['x-page-content']
      delete query['x-page-content']

    if query.query
      if typeof query.query is 'string'
        query.query = query.query.replace(/\+/g, ' ')
      else
        trace.instant('[INVALID SEARCH QUERY]', {query: query.query})
        query.query = ''

    if !requestURL
      if isHomePage
        requestURL = '/'
      else
        return

    extendedI18n = commonTranslate(modules.I18n)
    getPageUrl = partial getUrlForPageNumber, requestURL, query, minPrice, maxPrice

    resultsHtml: resultsHtml(startingIndex, endingIndex, totalDealCount, limitResults, extendedI18n)
    displayPagination: not isSinglePageDeals(currentPageNumber, nextPageSize, totalPages)
    previousPage: getPreviousPageTranslation(extendedI18n, modules)
    nextPage: getNextPageTranslation(extendedI18n)
    previousPageUrl: getPreviousPageUrl(requestURL, query, currentPageNumber, minPrice, maxPrice)
    nextPageUrl: getNextPageUrl(requestURL, query, currentPageNumber, nextPageSize, totalPages, minPrice, maxPrice)
    paginationSlots: getPaginationSlots(modules, currentPageNumber, totalPages, getPageUrl)

commonTranslate = (I18n) ->
  Object.assign {}, I18n, commonTranslate: (key, options) ->
    I18n.t(key, options)

getPaginationSlots = (modules, currentPageNumber, totalPages, getPageUrl) ->
  maxPaginationSlotsPerPage = 9
  useExpandingPagination = true

  PaginationSlots.toArray {
    currentPageNumber
    totalPages
    getPageUrl
    maxPaginationSlotsPerPage
    useExpandingPagination
  }

getParsedUrlFromQuery = (url) ->
  return unless url?
  try
    parsedURL = urlParse.parse(url, true)
  catch
    return
  requestURL: parsedURL.path
  query: parsedURL.query

getPreviousPageTranslation = (I18n, modules) ->
  I18n.commonTranslate('modules.pagination.presenters.previousShort')

getNextPageTranslation = (I18n) ->
  I18n.commonTranslate('modules.pagination.presenters.next')

getPreviousPageUrl = (requestURL, queryParams, currentPageNumber, minPrice, maxPrice) ->
  return if currentPageNumber is 1
  getUrlForPageNumber(requestURL, queryParams, minPrice, maxPrice, parseInt(currentPageNumber) - 1)

getNextPageUrl = (requestURL, queryParams, currentPageNumber, nextPageSize, totalPages, minPrice, maxPrice) ->
  return if currentPageNumber is totalPages
  return if not (nextPageSize > 0)
  getUrlForPageNumber(requestURL, queryParams, minPrice, maxPrice, parseInt(currentPageNumber) + 1)

resultsHtml = (startingIndex, endingIndex, totalDealCount, limitResults, I18n) ->
  translateOptions =
    strongOpen: "<strong>"
    strongClose: "</strong>"
    totalDealCount: totalDealCount
    startingIndex: startingIndex
    endingIndex: endingIndex

  if limitResults
    "<span>#{I18n.commonTranslate('modules.pagination.presenters.limited_results', translateOptions)}</span>"
  else
    "<span>#{I18n.commonTranslate('modules.pagination.presenters.results', translateOptions)}</span>"

getUrlForPageNumber = (requestURL, queryParams = {}, minPrice, maxPrice, pageNumber) ->
  paginationParams = clone queryParams
  delete paginationParams.page if paginationParams.page
  paginationParams.page = pageNumber unless pageNumber is 1

  baseUri = requestURL
  if baseUri.indexOf('?') > -1
    baseUri = baseUri.substring(0, baseUri.indexOf('?'))

  return baseUri if isEmpty(paginationParams)

  stringify = qs?.stringify ? toString

  if minPrice? and maxPrice?
    paginationParams.minPrice = minPrice
    paginationParams.maxPrice = maxPrice

  decodeParamsToCounterStringifyEncoding(paginationParams)

  "#{baseUri}?#{stringify paginationParams}" # Stringify will encode strings

decodeParamsToCounterStringifyEncoding = (paginationParams) ->
  Object.keys(paginationParams).forEach (key) ->
    return if(typeof paginationParams[key] != 'string')
    try
      paginationParams[key] = decodeURIComponent(paginationParams[key])
    catch

isSinglePageDeals = (pageNumber, nextPageSize, totalPages) ->
  return true if totalPages is 1
  return true unless pageNumber? and nextPageSize?
  return false unless pageNumber is 1
  return false unless nextPageSize <= 0
  true
